"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TwoCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TwoCircleFilled = function TwoCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208 35.72H29.52l-1.32.024c-.096.024-.384.024-.696.024.384-.936 1.464-1.944 3.408-3.192 1.728-1.152 2.352-1.632 2.952-2.28.912-.96 1.368-2.112 1.368-3.456 0-2.856-2.016-4.752-5.088-4.752-3.384 0-5.28 2.136-5.28 5.952h2.472c.096-2.688.888-3.792 2.736-3.792 1.584 0 2.568 1.032 2.568 2.688 0 .816-.264 1.56-.744 2.136-.408.504-1.056 1.008-2.736 2.112-3.504 2.304-4.584 3.84-4.704 6.816h10.752v-2.28z",
    fill: "#97BA1E"
  }));
};

exports.TwoCircleFilled = TwoCircleFilled;
var _default = TwoCircleFilled;
exports.default = _default;